export default "__VITE_ASSET__5TC8emS6__"